import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import 'react-quill/dist/quill.snow.css';
import { getInternational, updateInternational } from "../../actions/International";
import { IMAGE_URL } from "../../path";
import '../BusinessPage/style/BusinessStory.css';

function InternationalPage() {
    const ReactQuill = require('react-quill');
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean'],
        ],
    };

    const location = useLocation();
    const user = location.state?.user;
    const navigate = useNavigate();

    if (!location.state?.user) navigate('/login');

    const [isCollapsed, setIsCollapsed] = useState(true);
    const [internationalPage, setInternationalPage] = useState<any[]>([]);

    // Text sections
    const [copySection, setCopySection] = useState('');
    const [portfolioSection, setPortfolioSection] = useState('');
    const [teamSection, setTeamSection] = useState('');

    // Desktop and Mobile images
    const [desktopImages, setDesktopImages] = useState<(File | null)[]>([null, null, null]);
    const [mobileImages, setMobileImages] = useState<(File | null)[]>([null, null, null]);
    const [desktopPreviews, setDesktopPreviews] = useState<string[]>(['', '', '']);
    const [mobilePreviews, setMobilePreviews] = useState<string[]>(['', '', '']);

    const [imageError, setImageError] = useState('');

    // Full-width checkboxes
    const [fullWidth, setFullWidth] = useState<boolean[]>([false, false, false]);

    useEffect(() => {
        fetchInternational();
    }, []);

    function fetchInternational() {
        getInternational()
            .then(response => {
                const data = response.data;
                setInternationalPage(data);

                setCopySection(data[1]?.right_text || '');
                setPortfolioSection(data[3]?.right_text || '');
                setTeamSection(data[5]?.right_text || '');

                setDesktopPreviews([
                    IMAGE_URL + data[0]?.image,
                    IMAGE_URL + data[2]?.image,
                    IMAGE_URL + data[4]?.image
                ]);
                setMobilePreviews([
                    IMAGE_URL + data[0]?.mobile_image,
                    IMAGE_URL + data[2]?.mobile_image,
                    IMAGE_URL + data[4]?.mobile_image
                ]);

                // Load full width values from API (fallback to false)
                setFullWidth([
                    Boolean(data[0]?.is_full),
                    Boolean(data[2]?.is_full),
                    Boolean(data[4]?.is_full),
                ]);
            })
            .catch(error => {
                console.error("Failed to fetch international page:", error);
            });
    }

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, type: 'desktop' | 'mobile') => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
            setImageError("Please upload a valid image file (jpg, jpeg, png).");
            return;
        }

        const objectUrl = URL.createObjectURL(file);
        setImageError('');

        if (type === 'desktop') {
            const newDesktopImages = [...desktopImages];
            const newDesktopPreviews = [...desktopPreviews];
            newDesktopImages[index] = file;
            newDesktopPreviews[index] = objectUrl;
            setDesktopImages(newDesktopImages);
            setDesktopPreviews(newDesktopPreviews);
        } else {
            const newMobileImages = [...mobileImages];
            const newMobilePreviews = [...mobilePreviews];
            newMobileImages[index] = file;
            newMobilePreviews[index] = objectUrl;
            setMobileImages(newMobileImages);
            setMobilePreviews(newMobilePreviews);
        }
    };

    const removeImage = (index: number, type: 'desktop' | 'mobile') => {
        if (type === 'desktop') {
            const newDesktopImages = [...desktopImages];
            const newDesktopPreviews = [...desktopPreviews];
            newDesktopImages[index] = null;
            newDesktopPreviews[index] = IMAGE_URL + internationalPage[1 + index * 2]?.image;
            setDesktopImages(newDesktopImages);
            setDesktopPreviews(newDesktopPreviews);
        } else {
            const newMobileImages = [...mobileImages];
            const newMobilePreviews = [...mobilePreviews];
            newMobileImages[index] = null;
            newMobilePreviews[index] = IMAGE_URL + internationalPage[1 + index * 2]?.mobile_image;
            setMobileImages(newMobileImages);
            setMobilePreviews(newMobilePreviews);
        }
    };

    const saveInternationalPage = async () => {
        try {
            const formData = new FormData();

            formData.append('section1', copySection);
            formData.append('section2', portfolioSection);
            formData.append('section3', teamSection);

            desktopImages.forEach((file, i) => file && formData.append(`image${i + 1}`, file));
            mobileImages.forEach((file, i) => file && formData.append(`mobile_image${i + 1}`, file));

            // Full width booleans
            formData.append('image1_full_width', fullWidth[0] ? '1' : '0');
            formData.append('image2_full_width', fullWidth[1] ? '1' : '0');
            formData.append('image3_full_width', fullWidth[2] ? '1' : '0');

            const response = await updateInternational(formData);

            if (response.status === 201) {
                alert("International page saved successfully!");
                fetchInternational();
            } else {
                alert("Failed to save. Please try again.");
            }
        } catch (error) {
            console.error("Error saving international page:", error);
            alert("An error occurred while saving.");
        }
    };

    const renderImageInputs = (index: number) => (
        <div className="images-flex">
            <div className="content-form-field">
                <label><strong>Desktop Image {index + 1}</strong></label>
                <input type="file" accept=".jpg,.jpeg,.png" onChange={(e) => handleImageChange(e, index, 'desktop')} />
                {desktopPreviews[index] && (
                    <div>
                        <img src={desktopPreviews[index]} alt={`Desktop ${index + 1}`} style={{ maxWidth: '100%', maxHeight: '300px', marginTop: '10px' }} />
                        <br />
                        <button type="button" onClick={() => removeImage(index, 'desktop')}>Remove</button>
                    </div>
                )}
            </div>

            <div className="content-form-field">
                <label><strong>Mobile Image {index + 1}</strong></label>
                <input type="file" accept=".jpg,.jpeg,.png" onChange={(e) => handleImageChange(e, index, 'mobile')} />
                {mobilePreviews[index] && (
                    <div>
                        <img src={mobilePreviews[index]} alt={`Mobile ${index + 1}`} style={{ maxWidth: '100%', maxHeight: '300px', marginTop: '10px' }} />
                        <br />
                        <button type="button" onClick={() => removeImage(index, 'mobile')}>Remove</button>
                    </div>
                )}
            </div>

            {/* Full Width Checkbox */}
            <div className="content-form-field">
                <label style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                    <input
                        type="checkbox"
                        checked={fullWidth[index]}
                        onChange={(e) => {
                            const updated = [...fullWidth];
                            updated[index] = e.target.checked;
                            setFullWidth(updated);
                        }}
                    />
                    Full Width
                </label>
            </div>
        </div>
    );

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />
            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className="main-admin-page-inner">
                    <h2>International Page</h2>

                    {renderImageInputs(0)}
                    <div className="content-form-field">
                        <label><strong>{internationalPage[1]?.title || ''}</strong></label>
                        <ReactQuill value={copySection} onChange={setCopySection} modules={modules} style={{ minHeight: '200px', marginBottom: '50px' }} />
                    </div>

                    {renderImageInputs(1)}
                    <div className="content-form-field">
                        <label><strong>{internationalPage[3]?.title || ''}</strong></label>
                        <ReactQuill value={portfolioSection} onChange={setPortfolioSection} modules={{ toolbar: false }} style={{ minHeight: '200px', marginBottom: '50px' }} />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', width: '100%' }}>
                        <button
                            type="button"
                            onClick={() => navigate('/dashboard/international/brands/list', { state: { user } })}
                        >
                            View International Portfolio
                        </button>
                    </div>

                    {renderImageInputs(2)}
                    <div className="content-form-field">
                        <label><strong>{internationalPage[5]?.title || ''}</strong></label>
                        <ReactQuill value={teamSection} onChange={setTeamSection} modules={{ toolbar: false }} style={{ minHeight: '200px', marginBottom: '50px' }} />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', width: '100%' }}>
                        <button
                            type="button"
                            onClick={() => navigate('/dashboard/international/team/list', { state: { user } })}
                        >
                            View International Team
                        </button>
                    </div>

                    <div style={{ marginTop: '30px' }}>
                        <button onClick={saveInternationalPage} style={{ padding: '10px 20px', fontSize: '16px' }}>
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InternationalPage;
